import React from "react";

const Bash_Chmod = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Chmod</h2>
      <p>Change file mode bits (permissions).</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>chmod [options] mode file
chmod [ugoa][+-=][rwx] file</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>chmod 755 script.sh
chmod u+x script.sh
chmod o-r file.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Be careful setting world-writable permissions.</p>
    </div>
  );
};

export default Bash_Chmod;
